module.exports = __webpack_public_path__ + "img/fullscreen-white-18dp.8ca439c3.svg";